import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import './TopBar.css'
import { useEffect, useRef, useState } from 'react'

export function Topbar() {
    const { user, logout, isAdmin } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()
    const [open, setOpen] = useState(false)
    const ref = useRef<HTMLDivElement>(null)
    const isAdminRoute = location.pathname.startsWith('/admin')

    useEffect(() => {
        function handleClickOutside(e: MouseEvent) {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])
    return (
        <header className="topbar">
            <div className="brand" onClick={() => navigate('/catalogo')}>
                <div className="brand-mark">S</div>
                <div>
                    <span className="brand-name">S.I.M. Academy</span>
                    <span className="brand-tag">Gazin</span>
                </div>
            </div>

            <nav className="topnav">
                <button
                    className={!isAdminRoute ? 'on' : ''}
                    onClick={() => navigate('/catalogo')}
                >
                    Aluno
                </button>
                {isAdmin && (
                    <button
                        className={isAdminRoute ? 'on' : ''}
                        onClick={() => navigate('/admin')}
                    >
                        Admin
                    </button>
                )}
            </nav>

            {/* <div className="user-chip" onClick={() => setOpen(prev => !prev)}  title="Sair">
                <div className="user-meta">
                    <span className="name">{user?.name?.split(' ').slice(0, 2).join(' ')}</span>
                    {user?.branchCode && (
                        <span className="filial">{user.branchCode} · {user.branch}</span>
                    )}
                </div>
                <div className="avatar">{user?.initials}</div>
                {open && (
                <div className="user-dropdown">
                    <button
                        className="user-dropdown-item"
                        onClick={() => { setOpen(false); navigate('/change-password') }}
                    >
                        🔒 Alterar senha
                    </button>
                    <div className="user-dropdown-divider" />
                    <button
                        className="user-dropdown-item danger"
                        onClick={logout}
                    >
                        ↩ Sair
                    </button>
                </div>
            )}
            </div> */}
            <div className="user-menu-wrapper">
                <div
                    className="user-chip"
                    onClick={() => setOpen(prev => !prev)}
                >
                    <div className="user-meta">
                        <span className="name">
                            {user?.name?.split(' ').slice(0, 2).join(' ')}
                        </span>

                        {user?.branchCode && (
                            <span className="filial">
                                {user.branchCode} · {user.branch}
                            </span>
                        )}
                    </div>

                    <div className="avatar">
                        {user?.initials}
                    </div>
                </div>

                {open && (
                    <div className="user-dropdown">
                        <button
                            className="user-dropdown-item"
                            onClick={() => {
                                setOpen(false)
                                navigate('/atualizar-senha')
                            }}
                        >
                            <span>🔒</span>
                            Alterar senha
                        </button>
                        <button
                            className="user-dropdown-item"
                            onClick={() => {
                                setOpen(false)
                                navigate('/atualizar-email')
                            }}
                        >
                            <span>✉️</span>
                            Alterar E-mail
                        </button>
                        <div className="user-dropdown-divider" />

                        <button
                            className="user-dropdown-item danger"
                            onClick={logout}
                        >
                            <span>↩</span>
                            Sair
                        </button>
                    </div>
                )}
            </div>
        </header>
    )
}